var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPen2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m1.27 9.298 7.623-7.624 2.459 2.459-7.624 7.624zM.027 13l2.717-.753L.78 10.283zM12.035.382a1.307 1.307 0 0 0-1.845 0l-.554.553 2.458 2.459.554-.554c.51-.51.51-1.336 0-1.846z"
})));
export default SvgPen2;